// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"2f0ff9d6","905":"035bcc0b"}[chunkId] + ".chunk.js";
};